// removed by extract-text-webpack-plugin
module.exports = {"pagination__button_prev":"_1-NAmhKaq5FcuiWjRc1KlT","pagination__button_next":"_39qzUgSFcTvtXIgqo67xID","pagination":"_3ys5pxBhekm1q4qTfGuPUC","pagination_in-search-block":"_2gtXJ7prC8EIdS_yKLt84a","pagination__item":"_2tggERO0EJAfJTlAsMk-EP","pagination__item_prev":"xFaiG9CAk13Coeoh76mXO","pagination__item_next":"_2yr2PQ4wWEr_OstYpMNOqN","pagination__button":"_1sm_hu1PLCsoCkHwoaDMsQ","pagination__button_active":"KFBL0frfwi-13VHG0nVIg","pagination__button-dots":"g9O2MUBjWMJgbuAuXT-Q4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PaginatorBlock/PaginatorBlock.module.scss
// module id = 793
// module chunks = 0